import { FormErrorFragmentFragment } from 'data/__generated__';
import { type GraphQLFormattedError } from 'graphql';
import React from 'react';
import { toast } from 'react-toastify';

export async function handleUpdateResults<
    TData extends {
        success?: boolean | null;
        errors?: string[] | null;
        warnings?: string[] | null;
        formErrors?: FormErrorFragmentFragment[] | null;
        updatedItems?: unknown[] | null;
    },
>({
    data,
    errors,
    errorMessage,
    successMessage,
    onSuccess,
}: {
    data?: TData | null;
    errors?: readonly GraphQLFormattedError[] | null;
    errorMessage?: string;
    successMessage?: string;
    onSuccess?: () => void;
}): Promise<{ success: boolean }> {
    try {
        const dataErrors = data?.errors;
        const dataWarnings = data?.warnings;
        const dataFormErrors = data?.formErrors;

        if (errors && errors.length > 0) {
            errors.forEach((error, index) => {
                toast.error(React.createElement('span', { key: index }, `Erreur : ${error}`), { autoClose: false });
            });
        }

        // Gestion des erreurs
        if (dataErrors && dataErrors.length > 0) {
            dataErrors.forEach((error, index) => {
                toast.error(React.createElement('span', { key: index }, `Erreur : ${error}`), { autoClose: false });
            });

            if (dataErrors.length > 1) {
                toast.info('Cliquez pour fermer toutes les notifications', {
                    autoClose: false,
                    onClick: () => toast.dismiss(),
                });
            }
            return { success: false };
        }

        // Gestion des form errors
        dataFormErrors?.forEach(({ sectionName, sectionErrors }, index) => {
            toast.error(
                <span key={index}>
                    Erreur dans la section "{sectionName}" :
                    {sectionErrors.map(({ fieldName, fieldError }, index) => (
                        <span key={index}>
                            <br />- {fieldName} : "{fieldError}"
                        </span>
                    ))}
                </span>,
                { autoClose: false },
            );
        });
        if (dataFormErrors && dataFormErrors.length > 1) {
            toast.info('Cliquez pour fermer toutes les notifications', {
                autoClose: false,
                onClick: () => toast.dismiss(),
            });
        }

        if (data && data?.success === false) {
            toast.error(errorMessage || 'Une erreur est survenue');
            return { success: false };
        }

        // Gestion des avertissements
        if (dataWarnings && dataWarnings.length > 0) {
            dataWarnings.forEach((warning, index) => {
                toast.warning(React.createElement('span', { key: index }, `Avertissement : ${warning}`), {
                    autoClose: 5000,
                });
            });
        }

        toast.success(successMessage || 'Opération réussie');

        onSuccess?.();
        return { success: true };
    } catch (error) {
        toast.error("Erreur lors de l'update");
        return { success: false };
    }
}
